// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__RMjQZ","patna":"styles_patna__ivU62"};